export default __webpack_public_path__ + "static/media/49g.91683532.svg";